import React from "react";
import Modal from "../../../../elements/Modal";
import ManagePayment from "../ManagePayment";

const ManagePaymentModal = ({
  open,
  close = () => {},
  getResponse = () => {},
  data = {},
}) => {
  return (
    <Modal
      isOpen={open}
      setIsOpen={close}
      size="xl2"
      title={data?._id ? "Update" : "Create New "}
    >
      <ManagePayment getResponse={getResponse} close={close} details={data} />
    </Modal>
  );
};

export default ManagePaymentModal;
